import React  from 'react';
import {
  SortableContainer as SCWrapper,
  SortableContainerProps as SCWrapperProps,
  SortableElement as SEWrapper,
  SortableElementProps as SEWrapperProps,
} from 'react-sortable-hoc';


interface SortableElementProps extends SEWrapperProps {
  renderElement: () => React.ReactElement
}

interface SortableContainerProps extends SCWrapperProps {
  items: any[]
  renderElement: (item: any) => React.ReactElement
  disabled: boolean
  className?: string
}

const SortableElement = SEWrapper(
  (props: SortableElementProps) => props.renderElement()
)

const SortableContainer = SCWrapper(
  (props: SortableContainerProps) => (
    <div className={props.className}>
      {props.items.map((item: any, i: number) => {
        const renderElement = () => props.renderElement(item)

        return (
          <SortableElement
            key={item + '_sortable_' + i}
            index={i}
            disabled={props.disabled}
            renderElement={renderElement}
          />
        )
      })}
    </div>
  )
)

export default SortableContainer;